import React from "react";

import { Button, H1, Icon } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import { getBackendRoute } from "../../utils/AuthenticatedFetch";

export function Logo() {
  return (<img style={{ maxHeight: 100, maxWidth: 300, margin: 3, objectFit: "contain" }} className="noselect" src={getBackendRoute("HTTP") + "/settings/logo"} alt="your logo" />);
}

export default function Title(props) {
  return (
    <div className="flexbox-center-large" style={{ userSelect: "none" }}>
      <H1>
        <Icon icon={props.icon} /> <Trans>{props.text}</Trans>
      </H1>
      <div className="flexbox-right">
        <Logo />
        {props.closable && <div>
          <Button onClick={() => window.close()} icon="cross" minimal={true} />
        </div>}
      </div>
    </div>
  );
}
